import { render, staticRenderFns } from "./CollectionFilterTrim.vue?vue&type=template&id=62a8653d&"
import script from "./CollectionFilterTrim.vue?vue&type=script&lang=js&"
export * from "./CollectionFilterTrim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports